/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_FremdsprachenInputs */

const en__field_fremdsprachen = /** @type {(inputs: _Field_FremdsprachenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foreign Languages`)
};

const de__field_fremdsprachen = /** @type {(inputs: _Field_FremdsprachenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fremdsprachen`)
};

/**
* | output |
* | --- |
* | "Foreign Languages" |
*
* @param {_Field_FremdsprachenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_fremdsprachen = /** @type {((inputs?: _Field_FremdsprachenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_FremdsprachenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_fremdsprachen(inputs)
	return de__field_fremdsprachen(inputs)
});